export default {
  apiUrl: "https://beta-backend.kinnil.com",
  qaUrl:"http://qamm.kinnil.com",
  productionUrl: "http://app.kinnil.com",
  angularConfig: {
     apiKey: "AIzaSyB6sSGts9E3BBLFmlMLDeRPx20XA1tXSok",

  authDomain: "kinnil-mm-produccion.firebaseapp.com",

  projectId: "kinnil-mm-produccion",

  storageBucket: "kinnil-mm-produccion.appspot.com",

  messagingSenderId: "985407701316",

  appId: "1:985407701316:web:0e48469bb450afdccd9711",

  measurementId: "G-QF8L12GZ7K"

  }
}
